import "babel-polyfill";

import React from "react";

import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";

import { store, history } from "./redux/store";

import App from "./App";
import SwReload from "./components/sw-reload";

const target = document.querySelector("#root");

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <BrowserRouter>
        <div>
          <App />
          <SwReload />
        </div>
      </BrowserRouter>
    </ConnectedRouter>
  </Provider>,
  target
);



// WEBPACK FOOTER //
// ./src/js/index.js